// Canonical top-to-bottom order of report sections. Page numbers are computed
// by walking this list and accumulating each section's measured page count.
// Sections whose length depends on content (the response-rate table, the
// priority tables, the comment lists, words of wisdom) report their measured
// page count to Redux; every other section occupies exactly one page.
export const PAGE_ORDER = [
  'startingPage',
  'firstPage',
  'aboutPage',
  'outlineOfThisReport',
  'circumplexData',
  'topStrengths',
  'strenghtComments',
  'keyDevelopmentAreas',
  'devlopmentAreasComments',
  'twoByTwoMatrix',
  'wordsOfWisdom',
  'ratingsOnEachBehavior',
];

// Returns a map of sectionKey -> 1-based start page. A dynamic section that has
// not reported a count yet is assumed to be one page, so numbering settles as
// measurements arrive. The standard-deviation pages follow the last section.
export function computeStartPages(pageCounts = {}) {
  const startPages = {};
  let page = 1;
  PAGE_ORDER.forEach((key) => {
    startPages[key] = page;
    page += pageCounts[key] || 1;
  });
  startPages.standardDeviationSection = page;
  return startPages;
}
